import styled from 'styled-components';

import { flexAsColumn, flexAsRow, grid } from '@components/Styled/mixins';

const InvestorLocationModalWrapper = styled.div`
  ${grid(4)};

  width: 100%;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(2)};
  grid-template-rows: 2fr 0.5fr;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${grid(2)};

    width: 30vh;
    height: 48vh;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}px) {
    ${grid(4)};

    width: 70vh;
    height: 70vh;
    padding: ${({ theme }) => theme.spacing(6)};
  }
`;

const DescriptionContainer = styled.div`
  ${flexAsColumn(2)};

  align-items: center;
  text-align: center;

  & img {
    width: ${({ theme }) => theme.spacing(6)};
    height: ${({ theme }) => theme.spacing(6)};
  }

  & article {
    ${flexAsColumn(1)};
  }
`;

const ButtonsContainer = styled.div`
  ${flexAsColumn(2)};

  width: 100%;
  flex-flow: wrap-reverse;
  justify-content: center;

  & button {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}px) {
    ${flexAsRow(2)};

    margin-top: ${({ theme }) => theme.spacing(1)};

    & button {
      width: ${({ theme }) => theme.spacing(26.5)};
    }
  }
`;

const HelpContainer = styled.div`
  ${flexAsColumn()};

  width: 100%;
  height: 100%;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
`;

export {
  InvestorLocationModalWrapper,
  DescriptionContainer,
  ButtonsContainer,
  HelpContainer
};
